module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteClient":"Remove the client from this deal"},"fr":{"deleteClient":"Retirer le client de ce dossier"}}')
  delete Component.options._Ctor
}
